import React from 'react';
import { Instagram, Facebook, Mail, MapPin, Heart } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: '#edebe9' }}>
      {/* Decorative soft gradient blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-pink-200/30 to-purple-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-gradient-to-br from-blue-200/30 to-pink-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Connect with us heading */}
        <div className="text-center mb-8">
          <h3 className="text-2xl sm:text-3xl font-bold mb-2" style={{ color: '#3a2222' }}>
            Connect with us!
          </h3>
          <div className="flex items-center justify-center gap-2 text-sm" style={{ color: '#5a3535' }}>
            <span>Join our community</span>
            <Heart className="w-4 h-4 fill-current" style={{ color: '#c47e7e' }} />
          </div>
        </div>

        {/* Social media links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10">
          <a 
            href="https://www.instagram.com/cac_afth/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group relative bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #d4729e 0%, #c46060 100%)' }}>
                <Instagram className="w-4 h-4 text-white" />
              </div>
              <span className="text-sm sm:text-base font-medium" style={{ color: '#3a2222' }}>
                Follow us on Instagram
              </span>
            </div>
          </a>
          
          <a 
            href="https://www.facebook.com/cacafth/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group relative bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #6090c4 0%, #8060c4 100%)' }}>
                <Facebook className="w-4 h-4 text-white" />
              </div>
              <span className="text-sm sm:text-base font-medium" style={{ color: '#3a2222' }}>
                Like us on Facebook
              </span>
            </div>
          </a>
        </div>

        {/* Contact info */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-10">
          <a 
            href="mailto:cac-afth@e.ntu.edu.sg" 
            className="flex items-center gap-2 text-sm transition-colors hover:scale-105 duration-300"
            style={{ color: '#5a3535' }}
          >
            <div className="w-6 h-6 rounded-full flex items-center justify-center bg-white/60">
              <Mail className="w-3.5 h-3.5" style={{ color: '#d4a5a5' }} />
            </div>
            <span>cac-afth@e.ntu.edu.sg</span>
          </a>
          
          <div className="flex items-center gap-2 text-sm" style={{ color: '#5a3535' }}>
            <div className="w-6 h-6 rounded-full flex items-center justify-center bg-white/60">
              <MapPin className="w-3.5 h-3.5" style={{ color: '#a5b9d4' }} />
            </div>
            <span>Nanyang Technological University</span>
          </div>
        </div>

        {/* Decorative divider */}
        <div className="flex items-center justify-center mb-6">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-pink-300/50 to-transparent"></div>
          <div className="mx-4 w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#d4a5a5' }}></div>
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-purple-300/50 to-transparent"></div>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-xs sm:text-sm" style={{ color: '#5a3535' }}>
            © 2025 NTU CAC Arts From The Heart. All rights reserved.
          </p>
          <p className="text-xs mt-2" style={{ color: '#4a2a2a' }}>
            Made with love for our community
          </p>
        </div>
      </div>
    </footer>
  );
}